import { PageHead, Panel } from "@/components/staff/Bits";

const Item = ({ title, children }) => (
  <Panel title={title}><div className="text-[15px] leading-relaxed space-y-2">{children}</div></Panel>
);

export default function Procedures() {
  return (
    <div className="max-w-3xl space-y-5" data-testid="procedures-page">
      <PageHead title="Procedures" sub="Working draft for approval by the Parish Priest, Data Protection Officer and diocesan safeguarding office. Replace [placeholders] with verified local contacts." />
      <Item title="1. Emergency and escalation">
        <ol className="list-decimal pl-5 space-y-1">
          <li>If anyone is in immediate danger: call 911 (national emergency hotline) and [General Santos City local emergency / CDRRMO hotline].</li>
          <li>Inform the Pastoral Director the same day. Mark the case <b>Urgent</b> and, if applicable, <b>Escalate to safeguarding</b>.</li>
          <li>Never promise 24-hour monitoring. The platform is reviewed during parish office hours [office hours].</li>
        </ol>
      </Item>
      <Item title="2. Suspected abuse or child protection concern">
        <ol className="list-decimal pl-5 space-y-1">
          <li>Only designated, trained personnel handle safeguarding cases. Do not share them with general ministries or GKK officers.</li>
          <li>Report as required by law to [PNP Women and Children Protection Desk], [CSWDO / DSWD], and the [Diocese of Marbel safeguarding officer].</li>
          <li>Record facts, not opinions. Record the date and the authority to which you reported in a follow-up entry.</li>
        </ol>
      </Item>
      <Item title="3. Home visitation safeguards">
        <ul className="list-disc pl-5 space-y-1"><li>Visit in pairs; never be alone with a child or vulnerable adult.</li><li>Confirm the visit with the household first. Carry parish identification.</li><li>Do not share health histories or confidential conversations with GKK leadership.</li></ul>
      </Item>
      <Item title="4. Sacramental seal">
        <p>Never record the contents of sacramental confession or anything learned only in confession anywhere in this system. Messages sent through MABUHAY CARE are never sacramental confession.</p>
      </Item>
      <Item title="5. Corrections, data rights and breaches">
        <ul className="list-disc pl-5 space-y-1"><li>Correct mistakes using "Correct a detail" with a reason. Every change is recorded in the audit log; nothing is changed silently.</li><li>Requests for access, correction or deletion go to the [Data Protection Officer]. Records are not irreversibly deleted outside the approved retention schedule.</li><li>Suspected data breach: inform the DPO immediately. Notify the National Privacy Commission within 72 hours when required.</li></ul>
      </Item>
    </div>
  );
}
